import { FAILED_TO_GET_CLUBS, FETCHING_CLUBS, GOT_CLUBS, SELECTED_CLUB } from './club-search-reducer';
import fetch from '../utils/fetch-json';

export const searchForClubs =
    (searchString) =>
    ({ dispatch, getState }) => {
        const state = getState();
        const fullUrl = state.baseURL.concat(`/api/public/organization/club/search?q=${searchString}`);
        dispatch({ type: FETCHING_CLUBS, data: searchString });

        return fetch({ url: fullUrl, dispatch, getState })
            .then((response) => {
                dispatch({
                    type: GOT_CLUBS,
                    data: response.body.filter((club) => !!club.organizationNumber),
                });
            })
            .catch((error) =>
                dispatch({
                    type: FAILED_TO_GET_CLUBS,
                    data: error.body,
                })
            );
    };

export const selectedClub =
    ({ organizationNumber, organizationName }) =>
    ({ dispatch }) => {
        dispatch({ type: SELECTED_CLUB, data: { organizationNumber, organizationName } });
    };
